import { ButtonEvent } from "appworks/graphics/elements/button-element";
import { Layers } from "appworks/graphics/layers/layers";
import { UILayer } from "appworks/ui/ui-layer";
import { UIMenuButton } from "appworks/ui/ui-menu-button";
import { UIToggle } from "appworks/ui/ui-toggle";
import Logger = require("js-logger");
import { AbstractControl } from "./controls/abstract-control";
import { ControlFactory } from "./factories/control-factory";
import { UIFlagState } from "./flags/ui-flag-state";
import { UIFlag, uiFlags, UIMenuFlag } from "./flags/ui-flags";

export interface UIScene {
    scene: string;
    // Auto show when this flag state is met - defaults to UIFlagState.NEVER
    show?: UIFlagState;
    // Enable when this flag state is met, otherwise disable - defaults to match show
    enable?: UIFlagState;
}

export class UI {

    public static readonly factories: ControlFactory[] = [];

    public static layer(layer: Layers, uiScenes: UIScene[]) {
        if (this.initialised) {
            throw new Error("UI layers must all be created before UI.init()");
        }
        this.layers.push(new UILayer(layer, uiScenes));
    }

    public static button(layer: Layers, name: string, flag: UIMenuFlag, offFlags?: UIMenuFlag[]) {
        if (this.initialised) {
            throw new Error("UI menu buttons must all be created before UI.init()");
        }
/////////////////////////
/////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////
//////////////////
        this.buttons.push(new UIMenuButton(layer, name, flag, offFlags));
    }

    public static toggle(layer: Layers, name: string, flag: UIMenuFlag, offFlags?: UIMenuFlag[]) {
        if (this.initialised) {
            throw new Error("UI toggles must all be created before UI.init()");
        }
/////////////////////////
/////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////
//////////////////
        this.toggles.push(new UIToggle(layer, name, flag, offFlags));
    }

    public static init(factories: ControlFactory[]) {
        this.factories.push(...factories);

        this.initialised = true;
    }

    public static start() {
        this.layers.forEach((layer) => layer.start());
    }

    // Just for debugging which scenes are active for each UILayer
    public static getCurrentActiveScenes(): Array<{ layer: string, scene: string, enabled: boolean }> {
        return this.layers.map((layer) => {
            const currentSceneName = layer.layer.getCurrentScene().name;
            const currentUiScene = layer.uiScenes.find((uiScene) => uiScene.scene === currentSceneName);
            const enabled = currentUiScene && currentUiScene.enable.test();
            return { layer: layer.layer.id, scene: currentSceneName, enabled };
        });
    }

    private static readonly layers: UILayer[] = [];
    private static readonly buttons: UIMenuButton[] = [];
    private static readonly toggles: UIToggle[] = [];
    private static initialised: boolean;
}
